/**
 * Mega Menu Interactivity
 * Handles both the opening of the menu and the internal product hover effects.
 */
document.addEventListener('DOMContentLoaded', () => {
  const megaMenus = document.querySelectorAll('.mega-menu');

  megaMenus.forEach(menu => {
    const id = menu.id;
    const trigger = document.querySelector(`[aria-controls="${id}"]`);

    if (trigger) {
      // Show menu on trigger hover
      trigger.addEventListener('mouseenter', () => {
        trigger.setAttribute('aria-expanded', 'true');
        menu.classList.add('is-visible');
      });

      // Hide menu when leaving both trigger and menu
      const hideMenu = (e) => {
        setTimeout(() => {
          if (!trigger.matches(':hover') && !menu.matches(':hover')) {
            trigger.setAttribute('aria-expanded', 'false');
            menu.classList.remove('is-visible');
          }
        }, 10);
      };

      trigger.addEventListener('mouseleave', hideMenu);
      menu.addEventListener('mouseleave', hideMenu);
    }

    // Overlay click-to-close logic
    const overlay = menu.querySelector('.mega-menu__overlay');
    if (overlay) {
      overlay.addEventListener('click', () => {
        if (trigger) {
          trigger.setAttribute('aria-expanded', 'false');
        }
        menu.classList.remove('is-visible');
      });
    }

    // Internal Product Hover Logic
    const items = menu.querySelectorAll('.mega-menu__item');
    const featuredImg = menu.querySelector('.mega-menu__featured-img');
    const featuredLink = menu.querySelector('.mega-menu__featured-arrow-link');
    const tagContainer = menu.querySelector('.mega-menu__featured-tags');

    if (items.length > 0) {
      items.forEach(item => {
        item.addEventListener('mouseenter', () => {
          items.forEach(i => i.classList.remove('is-active'));
          item.classList.add('is-active');

          const image = item.getAttribute('data-product-image');
          const url = item.getAttribute('data-product-url');
          const tags = item.getAttribute('data-product-tags').split('|');

          if (featuredImg && image) {
            featuredImg.removeAttribute('srcset');
            featuredImg.src = image;
          }

          if (featuredLink && url) {
            featuredLink.href = url;
          }

          if (tagContainer) {
            tagContainer.innerHTML = '';
            tags.forEach(tag => {
              if (tag.trim() !== '') {
                const tagSpan = document.createElement('span');
                tagSpan.className = 'mega-menu__tag';
                tagSpan.textContent = tag;
                tagContainer.appendChild(tagSpan);
              }
            });
          }
        });
      });
    }
  });

  // Mobile Accordion Toggle Logic using event delegation
  document.body.addEventListener('click', (e) => {
    const toggle = e.target.closest('.mobile-accordion-toggle');
    if (toggle) {
      const content = toggle.nextElementSibling;
      const isExpanded = toggle.getAttribute('aria-expanded') === 'true';
      
      toggle.setAttribute('aria-expanded', !isExpanded);
      
      if (content) {
        if (!isExpanded) {
          content.style.display = 'block';
        } else {
          content.style.display = 'none';
        }
      }
    }
  });
});
